interface HeroProps {
  onCtaClick: () => void;
}

export default function Hero({ onCtaClick }: HeroProps) {
  const scrollToBeforeAfter = () => {
    const section = document.getElementById('before-after');
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 bg-[#0A0A0A]">
        <div className="absolute inset-0 opacity-20" style={{
          backgroundImage: `linear-gradient(#3B82F6 1px, transparent 1px), linear-gradient(90deg, #3B82F6 1px, transparent 1px)`,
          backgroundSize: '50px 50px'
        }}></div>
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-[#0A0A0A]/50 to-[#0A0A0A]"></div>
      </div>

      {/* Glow Effect */}
      <div className="absolute top-1/4 left-1/2 -translate-x-1/2 w-[600px] h-[600px] bg-[#3B82F6]/10 rounded-full blur-[120px]"></div>

      {/* Content */}
      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center pt-20">
        <h1 className="text-5xl md:text-7xl font-black leading-tight mb-6">
          Websites That Turn<br />
          <span className="text-[#3B82F6]">Visitors Into Booked Jobs.</span>
        </h1>
        
        <p className="text-xl md:text-2xl text-gray-300 mb-12 max-w-3xl mx-auto font-medium">
          We rebuild outdated service business websites into fast, mobile-first machines designed to generate more calls, more bookings, and more revenue.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <button 
            onClick={onCtaClick}
            className="bg-[#3B82F6] text-white px-8 py-5 rounded-lg text-lg font-black hover:bg-[#2563EB] transition-all shadow-lg shadow-[#3B82F6]/20 hover:shadow-[#3B82F6]/40 whitespace-nowrap cursor-pointer"
          >
            Get My Free Website Mockup
          </button>
          <button 
            onClick={scrollToBeforeAfter}
            className="border-2 border-[#3B82F6] text-[#3B82F6] px-8 py-5 rounded-lg text-lg font-black hover:bg-[#3B82F6]/10 transition-all whitespace-nowrap cursor-pointer"
          >
            See Before & After Examples
          </button>
        </div>

        {/* Scroll Indicator */}
        <div className="absolute bottom-10 left-1/2 -translate-x-1/2 animate-bounce">
          <div className="w-6 h-10 border-2 border-[#3B82F6] rounded-full flex items-start justify-center p-2">
            <div className="w-1 h-3 bg-[#3B82F6] rounded-full"></div>
          </div>
        </div>
      </div>
    </section>
  );
}
